<template>
    <div style="background-color: #fafafa;">
		<van-nav-bar title="购物车" left-text="产品列表" right-text="删除" left-arrow @click-left="onClickLeft" @click-right="onClickRight" fixed></van-nav-bar>
		<div class="psiConfirmCont">
			<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
				<van-list v-model="loading" :finished="finished" @load="onLoad" class="listBox" finished-text="">
					<van-checkbox-group v-model="checkIds" ref="checkboxGroup">
					<div v-for="(item, index) in list" class="card" :key="item.uuid">
						<table v-if="mainDescriptions.length > 0" class="layout" style="width: 100%;" >
							<tr style="width: 100%;" @click="selectCartItem(index)">
								<td :rowspan="item.type=='main' ? 18 : 10" style="width: 10%" >
									<van-checkbox :name="item.uuid" v-if="multiple" ref="checkboxes" slot="left-icon"/>
								</td>
								<td></td>
								<td></td>
							</tr>
							<tr style="width: 100%;" v-if="item.type=='main'" @click="selectCartItem(index)">
								<td colspan="2" class="content" style="width: 90%;">
									<p><span>{{mainDescriptions[1].fieldShowName}}：</span><span>{{item.radIdname}}</span></p>
								</td>
							</tr>
							<tr style="width: 100%;" v-if="item.type=='parts'" @click="selectCartItem(index)">
								<td colspan="2" class="content" style="width: 90%;">
									<p><span>{{partsDescriptions[0].fieldShowName}}：</span><span>{{item.radIdname}}</span></p>
								</td>
							</tr>
							<tr style="width: 100%;" v-if="item.type=='parts'" @click="selectCartItem(index)">
								<td colspan="2" class="content" style="width: 90%;">
									<p><span>{{partsDescriptions[1].fieldShowName}}：</span><span>{{item.skuIdname}}</span></p>
								</td>
							</tr>
							<template v-if="item.type==='main'">
								<tr v-for="(desc, i) in mainDescriptions" :key="desc.uuid">
									<td v-if="i>1 && i%2===0 && desc.inputType===6" style="width: 40%;" class="content"><span>{{desc.fieldShowName}}：</span><span>{{item[desc.fieldName+"name"]}}</span></td>
									<td v-if="i>1 && i%2===0 && i+1 < mainDescriptions.length && mainDescriptions[i+1].inputType===6" style="width: 50%;" class="content"><span>{{mainDescriptions[i+1].fieldShowName}}：</span><span>{{item[mainDescriptions[i+1].fieldName+"name"]}}</span></td>
									<td v-if="i>1 && i%2===0 && desc.inputType!==6" style="width: 40%;" class="content"><span>{{desc.fieldShowName}}：</span><span>{{item[desc.fieldName]}}</span></td>
									<td v-if="i>1 && i%2===0 && i+1 < mainDescriptions.length && mainDescriptions[i+1].inputType!==6" style="width: 50%;" class="content"><span>{{mainDescriptions[i+1].fieldShowName}}：</span><span>{{item[mainDescriptions[i+1].fieldName]}}</span></td>
								</tr>
							</template>
							<template v-if="item.type==='parts'">
								<tr v-for="(partsDesc, j) in partsDescriptions" :key="partsDesc.uuid">
									<td v-if="j>1 && j%2===0" style="width: 40%;" class="content"><span>{{partsDesc.fieldShowName}}：</span><span>{{item[partsDesc.fieldName]}}</span></td>
									<td v-if="j>1 && j%2===0 && j+1 < partsDescriptions.length" style="width: 50%;" class="content"><span>{{partsDescriptions[j+1].fieldShowName}}：</span><span>{{item[partsDescriptions[j+1].fieldName]}}</span></td>
								</tr>
							</template>
							<tr style="width: 100%;">
								<td style="width: 40%;" class="content"><span>数量：</span></td>
								<td style="width: 50%;"><van-stepper v-model="item.quantity" integer theme="round" @change="onChange(item)"/></td>
							</tr>
						</table>
						<table v-if="mainDescriptions.length === 0" class="layout" style="width: 100%;" >
							<tr style="width: 100%;" @click="selectCartItem(index)">
								<td :rowspan="item.type=='main' ? 7 : 4" style="width: 10%" >
									<van-checkbox :name="item.uuid" v-if="multiple" ref="checkboxes" slot="left-icon"/>
								</td>
								<td></td>
								<td></td>
							</tr>
							<tr style="width: 100%;" v-if="item.type=='main'" @click="selectCartItem(index)">
								<td colspan="2" class="content" style="width: 90%;">
									<p><span>产品系列-型号：</span><span>{{item.radCategoryname}}-{{item.radIdname}}</span></p>
								</td>
							</tr>
							<tr style="width: 100%;" v-if="item.type=='parts'" @click="selectCartItem(index)">
								<td colspan="2" class="content" style="width: 90%;">
									<p v-if="item.type=='parts'"><span>配件系列：</span><span>{{item.radCategoryname}}</span></p>
									<p v-if="item.type=='parts'"><span>配件型号：</span><span>{{item.radIdname}}</span></p>
									<p v-if="item.type=='parts'"><span>配件规格：</span><span>{{item.skuIdname}}</span></p>
									<p v-if="item.type=='parts'"><span>单位：</span><span>{{item.skuUnit}}</span></p>
								</td>
							</tr>
							<tr style="width: 100%;" v-if="item.type=='main'" @click="selectCartItem(index)">
								<td style="width: 40%;" class="content"><span>片数：</span><span>{{item.pieces}}</span></td>
								<td style="width: 50%;" class="content"><span>高度分类：</span><span>{{item.centerCategoryname}}</span></td>
							</tr>
							<tr style="width: 100%;" v-if="item.type=='main'" @click="selectCartItem(index)">
								<td style="width: 40%;" class="content"><span>高度：</span><span>{{item.centerSpacing}}</span></td>
								<td style="width: 50%;" class="content"><span>接口口径：</span><span>{{item.calibername}}</span></td>
							</tr>
							<tr style="width: 100%;" v-if="item.type=='main'" @click="selectCartItem(index)">
								<td style="width: 40%;" class="content"><span>颜色：</span><span>{{item.colorname}}</span></td>
								<td style="width: 50%;" class="content"><span>进水方式：</span><span>{{item.waterFlowname}}</span></td>
							</tr>
							<tr style="width: 100%;" v-if="item.type=='main'" @click="selectCartItem(index)">
								<td colspan="2" class="content"><p><span>特殊定制：</span><span>{{item.isSpecials}}</span></p></td>
							</tr>
							<tr style="width: 100%;">
								<td style="width: 40%;" class="content"><span>数量：</span></td>
								<td style="width: 50%;"><van-stepper v-model="item.quantity" integer theme="round" @change="onChange(item)"/></td>
							</tr>
						</table>
					</div>
					</van-checkbox-group>
				</van-list>
			</van-pull-refresh>
		</div>
		<div class="recordBox">
			<table style="width: 100%;margin-bottom: 3px;border-spacing:0;">
				<tr style="height:35px;padding: 0;">
					<td style="width: 40%;color:white;text-align: right;background-color: #555555;padding-left: 20px;"><van-checkbox v-model="isAll" icon-size="10px" @change="checkAll()">全选</van-checkbox></td>
					<td style="width: 30%;color:white;background-color: #555555;">合计：{{ quantity }}</td>
					<td style="width: 30%;background-color:#ee0a24;" ><van-button type="danger" native-type="button" size="large" @click="getIntoOrder()">下单</van-button></td>
				</tr>
			</table>
		</div>
    </div>
</template>

<script>
    import {Tab, Tabs, Panel, Button, List, Search, Popup, PullRefresh, NavBar, Stepper, Toast, Checkbox, CheckboxGroup, Dialog} from 'vant';
	import dealerOrderService from "../../service/dealerOrderService";
    import {formatDictionary} from "../../utils/dictionary";
	import moment from "moment";
	import configService from "../../service/configService";
    export default {
        data: function () {
            return {
                list: [],
                loading: false,
                finished: false,
                pageIndex: 0,
                refreshing: false,
				multiple: true,
				checkIds:[],
				quantity: 0,
				isAll: false,
				mainDescriptions: [],
				partsDescriptions: []
            }
        },
      
        components: {
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Button.name]: Button,
            [PullRefresh.name]: PullRefresh,
            [Panel.name]: Panel,
            [List.name]: List,
            [Search.name]: Search,
            [Popup.name]: Popup,
            [Stepper.name]: Stepper,
			[NavBar.name]: NavBar,
			[Checkbox.name]: Checkbox,
			[CheckboxGroup.name]: CheckboxGroup
        },
		created: async function () {
			let configValue = await configService.getConfigByName("是否配置购物车显示名");
			if (configValue.data.Status === "1"){
				if (configValue.data.Data && configValue.data.Data.value === "是"){
					let mainResp = await dealerOrderService.getCartDescriptionList("main");
					if (mainResp.data.Status === "1" && mainResp.data.Data && mainResp.data.Data.length>0){
						this.mainDescriptions = mainResp.data.Data;
					}
					let partsResp = await dealerOrderService.getCartDescriptionList("parts");
					if (partsResp.data.Status === "1" && partsResp.data.Data && partsResp.data.Data.length>0){
						this.partsDescriptions = partsResp.data.Data;
					}
				}
			}
		},
        methods: {
            async onLoad() {
                this.pageIndex++;
                let resp = await dealerOrderService.getSkuCartList(this.pageIndex);
                resp.data.Data.data.forEach(item => {
                    item.createTime = moment(item.createTime).format('YYYY-MM-DD');
					if(item.isSpecials && item.isSpecials.length > 22){
						let temp = item.isSpecials;
						item.isSpecials = temp.substring(0, 22);
						item.isSpecials += "...";
					}
                });
                formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                this.loading = false;
                this.refreshing = false;
                this.list = [...this.list, ...resp.data.Data.data];
                this.finished = resp.data.Data.total <= this.list.length;
            },
            onRefresh() {
                this.finished = false;
                this.loading = true;
                this.pageIndex = 0;
                this.list = [];
                this.onLoad();
            },
			async onChange(item){
				let resp = await dealerOrderService.updateSkuCartInfo(item.uuid, item.quantity);
				if (resp.data.Status === "1"){
					this.getCartQuantity(this.checkIds.join(","));
				} else {
					Toast.fail(resp.data.Message);
				}
			},
			selectCartItem(index){
				this.$refs.checkboxes[index].toggle();
			},
			checkAll(){
            	if(this.isAll){
					this.$refs.checkboxGroup.toggleAll(true);
				}else{
					this.$refs.checkboxGroup.toggleAll();
				}
			},
			async getCartQuantity(ids){
            	if(ids.length ===0){
					this.quantity = 0;
					return;
				}
				let resp = await dealerOrderService.getCartQuantity(ids);
				if (resp.data.Status === "1") {
					this.quantity = resp.data.Data || 0;
				}
			},
			async getIntoOrder(){
				if(this.checkIds.length === 0){
					Toast.fail("请选择要下单的产品或配件！");
					return;
				}
				Toast.loading({
					duration:0,
					message: '处理中...',
					forbidClick: true,
				});
				let resp = await dealerOrderService.getIntoOrder(this.checkIds.join(","));
				if (resp.data.Status === "1"){
					Toast.clear();
					this.$router.push({path:"/app/forms/bd47b33ddd334e93a6c17782b51c5f89/"+resp.data.Data});
				} else {
					Toast.clear();
					Toast.fail(resp.data.Message);
				}
			},
			onClickLeft(){
				this.$router.push({path:"orderSku",  query:{type: "0"}} );
			},
			onClickRight(){
            	if(this.checkIds.length === 0){
					Toast.fail("请选择要删除的产品或配件！");
					return;
				}
				Dialog.confirm({
					title: '',
					message: '确定要将选择的商品移出购物车吗？'
				}).then(() => {
					this.deleteCartItems();
				}).catch(() => {
					return;
				});
			},
			async deleteCartItems(){
				let resp = await dealerOrderService.deleteCartItemByIds(this.checkIds.join(","));
				if (resp.data.Status === "1"){
					Toast.success("删除成功！");
					this.quantity = 0;
					this.checkIds = [];
					this.isAll = false;
					this.onRefresh();
				} else {
					Toast.fail(resp.data.Message);
				}
			},
        },
		watch: {
        	 checkIds(){
        		this.getCartQuantity(this.checkIds.join(","));
			}
		}
    };

</script>
<style>
	.card p {
		margin:10px 0;
	}
	.card p>span:first-child {
		flex: 0 0 4rem;
		text-align: right;
		margin-right: 20px;
	}
	.van-pull-refresh__head{
		display: none;
	}
	.van-checkbox__label{
		color: white;
	}
	.recordBox {
		padding: 0.5rem 0;
		box-sizing: border-box;
		margin-top: 2rem;
		bottom:0;
		position:fixed;
		width: 100%;
	}
	.psiConfirmCont{
		width:100%;
		margin:0 auto;
		margin-top:100px;
		overflow: hidden;
		padding-bottom: 150px;
	}
</style>